import { useTranslator } from '@gandi/translate';
import { useAppSelector } from '../../../../../../hooks/useAppSelector';
import { selectCartCurrency } from '../../../../../../modules/selectors';
import { selectCartWidgetShowPrices } from '../../../../../../modules/widget/selectors';
import { NO_PRICE } from '../../helpers';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "Price-root_BsVZE"
};
function showCrossedPrice(crossedPrice, price) {
  return typeof crossedPrice === 'number' && typeof price === 'number' && crossedPrice > price;
}
export function Price({
  crossedPrice,
  price
}) {
  const {
    formatPrice
  } = useTranslator();
  const currency = useAppSelector(selectCartCurrency);
  const prices = useAppSelector(selectCartWidgetShowPrices);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.root,
    children: [showCrossedPrice(crossedPrice, price) && /*#__PURE__*/_jsx("del", {
      className: styles.priceCrossedOut,
      children: formatPrice(crossedPrice, currency)
    }), /*#__PURE__*/_jsx("span", {
      children: price === NO_PRICE || !prices ? NO_PRICE : formatPrice(Number(price), currency)
    })]
  });
}